import i18n from "i18n";
import AppConfig from "util/AppConfig";
import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import { DEFAULT_PRODUCT_NAME } from "brand-customization/useProductName";
export const eventDefinitionTypeTitle = (plugin) => (plugin == null ? void 0 : plugin.displayNameKey) ? i18n.t(plugin.displayNameKey) : plugin == null ? void 0 : plugin.displayName;
export const eventDefinitionTypeDescription = (plugin) => {
  var _a, _b, _c, _d;
  return (plugin == null ? void 0 : plugin.descriptionKey) ? i18n.t(plugin.descriptionKey, { productName: (_d = (_c = (_b = (_a = AppConfig).branding) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.product_name) != null ? _d : DEFAULT_PRODUCT_NAME }) : plugin == null ? void 0 : plugin.description;
};
const FIELD_VALUE_PROVIDER_TITLE_KEYS = {
  "template-v1": "field_value_providers.template.title",
  "lookup-v1": "field_value_providers.lookup_table.title"
};
export const fieldValueProviderTitle = (plugin) => {
  const key = FIELD_VALUE_PROVIDER_TITLE_KEYS[plugin == null ? void 0 : plugin.type];
  return key ? i18n.t(key, { ns: "event_definitions" }) : plugin == null ? void 0 : plugin.displayName;
};
export const priorityTitle = (priority) => {
  const properties = EventDefinitionPriorityEnum.properties[priority];
  return properties ? i18n.t(`priorities.${properties.name}`, { ns: "event_definitions" }) : String(priority);
};
